import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
} from "reactstrap"

import { LoadingGate, ResourceError } from "../../components"
import React, { useEffect } from "react"
import { fetchResources } from "../../actions"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import moment from "moment"

// Built from the customer's subscriptions (/orders) rather than
// /subscribed (subscribedskus): subscribedskus needs delegated admin rights
// into the customer tenant, so for customers without them Partner Center
// answers 403 and this card stayed empty. Subscriptions carry the purchased
// quantity and the commitment end date, which is what the card shows.
const Licenses = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchResources({ resource: "orders" }))
  }, [dispatch])

  const orders = useSelector((state) => state.orders)

  const licenses = orders.orders
    .filter((order) => order.type === "office")
    .filter((order) => order.status !== "deleted")

  const expired = (order) =>
    order.commitmentEndDate &&
    moment(order.commitmentEndDate).isBefore(moment())

  return (
    <Card>
      <CardHeader>{t("_licenses")}</CardHeader>
      <CardBody>
        <LoadingGate loading={orders.fetching}>
          {orders.error ? (
            <ResourceError resource={orders} />
          ) : licenses.length === 0 ? (
            <p className="text-muted mb-0">{t("_noLicenses")}</p>
          ) : (
            <ListGroup flush>
              {licenses.map((license) => (
                <ListGroupItem
                  key={license.id}
                  tag="a"
                  href={`/#/licenses/${license.id}`}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span>
                    {license.name}
                    {license.commitmentEndDate && (
                      <small
                        className={`d-block ${
                          expired(license) ? "text-danger" : "text-muted"
                        }`}
                      >
                        {t("_commitmentEndDate")}:{" "}
                        {moment(license.commitmentEndDate).format("DD.MM.YYYY")}
                      </small>
                    )}
                  </span>
                  <Badge color="primary" pill title={t("_quantity")}>
                    {license.quantity}
                  </Badge>
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </LoadingGate>
      </CardBody>
    </Card>
  )
}

export default Licenses
